import { Pipe, PipeTransform } from '@angular/core';

import { AuthenticationService } from '@core/service';
import { EmailRegExp } from '@shared/constants';
import { of, Observable } from 'rxjs';

@Pipe({
    name: 'userProfileCredentialsByEmail',
    standalone: false
})
export class GetUserProfileCredentialsByEmailPipe implements PipeTransform {

  constructor(
    private authenticationService: AuthenticationService
  ) { }

  transform(value: any): Observable<string> {
    return (value && EmailRegExp.test(value)) ? this.authenticationService.getUserProfileCredentialsByEmail(value) : of(value);
  }
}
